import {getSelectorParts, isSelectableProperty, isSelector} from './';

function resolveSelectorChain(id, name, path, propertyResolver, componentRegistry) {
	const property = propertyResolver(componentRegistry, id, name, path);
	if (property && property[0] === '@') {
		const [id, name, path] = getSelectorParts(property);
		return resolveSelectorChain(id, name, path, propertyResolver, componentRegistry);
	}

	return property;
}

/**
 * Returns property selector parts for a single property
 * @function resolveSelectedProperty
 * @private
 *
 * @param {Object} componentRegistry - Component registry
 * @param {function} propertyResolver - Returns the value for a property
 * @param {Object} property - property to be resolved
 * @param {Object} propertyDef - property definition from the config
 * @returns {Object} - The  resolved property
 */
export default function resolveSelectedProperty(
	componentRegistry,
	propertyResolver,
	property,
	propertyDef
) {
	const [id, name, path] = getSelectorParts(property);

	if (!id || !name) return property;

	const defaultValue = propertyDef && propertyDef.default;
	if (!isSelectableProperty(componentRegistry, id, name))
		return !isSelector(defaultValue) ? defaultValue : undefined;

	const resolvedValue = resolveSelectorChain(id, name, path, propertyResolver, componentRegistry);
	if (resolvedValue !== undefined) return resolvedValue;

	return !isSelector(defaultValue) ? defaultValue : undefined;
}
